import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BRAND, { applyBrandToHead } from './brand'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/style.css'
import VueRource from 'vue-resource'
import axios from 'axios';
// import Swiper from 'swiper'
// import '../../node_modules/swiper/swiper-bundle.min.css'


// import './assets/css/all.min.css'
// import './assets/css/aos.css'
// import './assets/css/css2.css'
// import './assets/css/style.scss'
// import './assets/js/aos.js'
// import './assets/js/script'


axios.defaults.timeout = 60 * 1000;

Vue.prototype.$axios=axios
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueRource)
// Vue.use(Swiper)

// 按访问域名写入品牌文案（title / keywords / description）
// index.html 只能写死一份，真正的按域名区分在这里运行时覆盖
applyBrandToHead(BRAND)
Vue.prototype.$brand = BRAND

new Vue({
  render: h => h(App),
  router
}).$mount('#app')